<template>
  <section>
    <b-modal size="lg" :id="modalId" :ref="modalId"
             @show="resetModal(true)"
             @ok="saveTask"
             :ok-title="okTitle"
             :ok-disabled="isSaving"
             title="Close/Reschedule Task"
             no-close-on-backdrop
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <i class="fa fa-2x mr-2" :class="findIconClass(taskDetails.taskTypeId)"></i>
          <h5>{{taskDetails.taskPriorityName}} - {{taskDetails.subject}}</h5>
        </div>
      </div>
      <div class="d-flex w-100 mt-1 mr-3">
        <div>
          <div class="h6 m-0">Contact / Company</div>
          <div>{{taskDetails.contactFirstName}} {{taskDetails.contactFirstName}} / {{taskDetails.companyName}}</div>
        </div>
        <h6>{{taskDetails.accountType}}</h6>
      </div>
      <div class="d-flex w-100 mt-1">
        <div class="mr-3">
          <div class="h6 m-0">Assigned</div>
          <div>{{taskDetails.assignedToUserFullName}}</div>
        </div>
        <div class="mr-3">
          <div class="h6 m-0">Due</div>
          <div>{{taskDetails.taskDueDateString}} {{taskDetails.taskDueHour}}:{{taskDetails.taskDueMinute}}
            {{taskDetails.taskDueAmPm}}
          </div>
        </div>
        <div class="mr-3">
          <div class="h6 m-0">Aging</div>
          <div>{{taskDetails.aging}} days</div>
        </div>
      </div>
      <b-row class="mb-2 mt-1">
        <b-col>
          <b-form-group label="Note (Enter your note for the task)">
            <b-form-textarea rows="3" v-model.trim="newNote"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2 ml-1">
        <b-form-group label="Due" class="required mr-2" style="width: 100px">
          <date-picker v-model="formData.taskDue" :config="datePickerOptions" size="sm"
                        :class="{ 'is-invalid': $v.formData.taskDue.$error }" @input="dateChanged()"/>
          <b-form-invalid-feedback>Please select task due date</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="mr-2" style="width:60px; margin-top: 18px">
          <b-form-select v-model="formData.taskDueHour" size="sm" @change="dateChanged()">
            <option v-for="(n,index) in 12" :key="index" :value="n">
              {{ (n).toLocaleString('en', {minimumIntegerDigits:2,useGrouping:false}) }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group class="mr-2" style="width:60px; margin-top: 18px">
          <b-form-select v-model="formData.taskDueMinute" size="sm" @change="dateChanged()">
            <option value="0">00</option>
            <option v-for="(n,index) in 3" :key="index" :value="n*15">
              {{ (n*15).toLocaleString('en', {minimumIntegerDigits:2,useGrouping:false}) }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group class="mr-2" style="width:60px; margin-top: 18px">
          <b-form-select v-model="formData.taskDueAmPm" size="sm" @change="dateChanged()">
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </b-form-select>
        </b-form-group>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  import { date } from '@/shared/filters';
  import { DATE_FORMAT, TODO_TASK_TYPES } from '@/shared/constants';

  export default {
    components: {},
    props: {
      taskDetails: {
        type: Object,
        default: () => {
        },
      },
    },
    data() {
      return {
        taskTypes: TODO_TASK_TYPES,
        modalId: 'close-task-modal',
        dateFilter: date,
        newNote:'',
        formData: {
          id: 0,
          taskDue: new Date(),
          taskDueHour: '1',
          taskDueMinute: '0',
          taskDueAmPm: 'AM',
          taskStatusId: 411,
          notes: '',
        },
        isSaving: false,
        okTitle: 'Close',
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: true,
        },
      };
    },
    validations: {
      formData: {
        taskDue: { required },
      },
    },
    computed: {
      ...mapGetters('account',['userId'])
    },
    methods: {
      ...mapActions('todotasks', ['manageTask']),
      async resetModal(getData = false) {
        this.$v.$reset();
        this.newNote='';
        if (getData && this.taskDetails) {
          this.isSaving=false;
          this.okTitle='Close';
          this.setFormData(this.taskDetails);
        }
      },
      dateChanged() {
        if (this.dateFilter(this.taskDetails.taskDue) != this.dateFilter(this.formData.taskDue) ||
          this.taskDetails.taskDueHour != this.formData.taskDueHour ||
          this.taskDetails.taskDueMinute != this.formData.taskDueMinute ||
          this.taskDetails.taskDueAmPm != this.formData.taskDueAmPm
        ) {
          this.okTitle = 'Save';
          this.formData.taskStatusId = 410;
        } else {
          this.okTitle = 'Close';
          this.formData.taskStatusId = 411;
        }
      },
      findIconClass(taskTypeId) {
        if (taskTypeId) {
          const myData = _.find(this.taskTypes, {id: taskTypeId});
          if (typeof myData !== 'undefined') {
            return myData.icon;
          }
        }
      },
      async saveTask(e) {
        e.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        this.okTitle = 'Saving...';
        try {
          this.isSaving = true;
          if (this.newNote !== '') {
            let existingNotes = (this.taskDetails.notes) ? JSON.parse(this.taskDetails.notes) : [];
            existingNotes.push({noteDate: new Date(), addedBy: this.userId, noteDetail: this.newNote});
            this.formData.notes = JSON.stringify(existingNotes);
          } else {
            this.formData.notes = this.taskDetails.notes;
          }
          await this.manageTask({...this.taskDetails, ...this.formData});
          this.$bvModal.hide(this.modalId);
          this.resetModal();
          this.$emit('refreshGrid');
          this.isSaving = false;
          this.okTitle = 'Close';
        } catch (e) {
          this.isSaving = false;
        }
      },

      setFormData(taskDetails) {
        this.formData = {
          id: taskDetails.id || 0,
          taskStatusId: 411,
          taskDue: (taskDetails.taskDue) ? this.dateFilter(taskDetails.taskDue) : new Date(),
          taskDueHour: taskDetails.taskDueHour || 1,
          taskDueMinute: taskDetails.taskDueMinute || 0,
          taskDueAmPm: taskDetails.taskDueAmPm || 'AM',
          notes: taskDetails.notes || '',
        };
        this.datePickerOptions.minDate = new Date(this.formData.taskDue);
      },
    },
    watch: {
      taskDetails() {
        this.setFormData(this.taskDetails);
      },
    },
    async mounted() {
      //this.setFormData();
    },
  };
</script>
